<template>
  <div class="news-coop p-10">
    <div class="ly-card search-content">
      <div class="btn-group"></div>
      <div class="search-group">
        <el-select clearable v-model="searchFormData.status" placeholder="全部">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
        <el-input placeholder="标题关键词" v-model.trim="searchFormData.keyword" @keypress.enter.native="search" />
        <el-button type="primary" size="medium" @click="search">查询</el-button>
      </div>
    </div>
    <div class="ly-card">
      <ly-table :getTableData="getTableData" :tableHeader="tableHeader" :searchFormData="searchFormData" ref="lyTable">
        <template v-slot:action="row">
          <el-button @click="read(row)" type="text" v-if="!row.status">回访</el-button>
          <span v-else>已回访</span>
        </template>
      </ly-table>
    </div>
  </div>
</template>

<script>
import { Input, Select, Option } from 'element-ui';
import { frontInf } from '@/api';
import LyTable from '@/components/LyTable';
import { coopTable } from '@/utils/tableHeader';

export default {
  name: 'Cooperation',
  components: {
    LyTable,
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option
  },
  data() {
    return {
      searchFormData: {
        keyword: '',
        status: ''
      },
      tableHeader: coopTable,
      getTableData: frontInf.getCooperation,
      options: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.search();
      frontInf.cooperationStatus().then(res => {
        if (res) this.options = res.data.list;
      });
    },
    search() {
      this.$refs.lyTable.setData();
    },
    openDetail({ explain }) {
      this.$alert(explain, '详情', { showConfirmButton: false })
        .then(() => {})
        .catch(() => {});
    },
    read(row) {
      frontInf
        .controlCooperation({
          id: row.id,
          methold: 'put'
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '信息已读！');
            this.search();
          }
        });
      this.openDetail(row);
    }
  }
};
</script>

<style lang="less">
.news-coop {
  .search-content {
    display: flex;
    justify-content: space-between;
    .search-group .el-input {
      width: 150px;
      margin-right: 20px;
    }
  }
  .idea-content {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
